module.exports = __webpack_public_path__ + "static/media/ic-square-pixel.2ae71043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-square-pixel.svg
// module id = 672
// module chunks = 14